import React from "react";
import {observer, inject} from "mobx-react";
import {withRouter, Route, Link, Switch} from "react-router-dom";
import ErrorBoundry from "@components/ErrorBoundry/ErrorBoundry";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import debounce from '@utils/debounce';
import axios from "axios";
import getBoxPadUrl from "@utils/getBoxPadUrl"
import Modal from "@components/react-responsive-modal/modal";
import queryString from "query-string";
import {QuantityEdit} from "../Products/QuantityEdit";

@inject("store")
@observer
class SearchViewModal extends React.Component {

    constructor(props) {
        super(props);

        this.searchProducts = debounce(this.searchProducts.bind(this), 350);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.openProduct = this.openProduct.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.viewResult = this.viewResult.bind(this);
        this.request = this.request.bind(this);
        this.setActive = this.setActive.bind(this);
        this.setNotActive = this.setNotActive.bind(this);
        this.clearSearchQuery = this.clearSearchQuery.bind(this);

        //this.close = this.close.bind(this);
        this.modalRef = React.createRef();

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.state = {
            cursor: -1,
            products: [],
            totalResults: 0,
            searchQuery: "", // this.props.store.navigation.getFreetextFromLocation(),
            isActive: false,
            didClear: false,
            modalOpen: false,
            fontClasses: ["fas", "search"]
        }
    }

    // close() {
    //     const navigation = this.props.store.navigation;
    //     navigation.toolbarRouter.push("/");
    //     navigation.setNavigationVisible(false);
    // }

    componentDidUpdate(prevProps, prevState) {

        //let searchQuery = this.props.store.navigation.getFreetextFromLocation();

        // if (!searchQuery) {
        //     searchQuery = "";
        // }

        // if (this.state.searchQuery !== searchQuery && !this.state.isActive && !this.state.didClear) {
        //     this.setState({searchQuery: searchQuery});
        //
        //     if (searchQuery.length === 0) {
        //         this.setState({
        //             cursor: -1,
        //             products: [],
        //             totalResults: 0,
        //             didClear: false
        //         });
        //     }
        // }
    }

    componentDidMount() {
        const navigation = this.props.store.navigation;
        navigation.setNavigationVisible(true);
        //this.setState({ modalOpen: true);
        //let searchQuery = this.props.store.navigation.getFreetextFromLocation();

        // if (!searchQuery) {
        //     searchQuery = "";
        // }


        //this.setState({ searchQuery: searchQuery });

//        if (searchQuery.length === 0) {
        this.setState({
            modalOpen: true,
            searchQuery: "",
            cursor: -1,
            products: [],
            totalResults: 0
        });
        //}


        // if (this.state.searchQuery !== searchQuery && !this.state.isActive) {
        // }
        //this.setActive();
    }

    clearSearchQuery(e) {
        this.setNotActive();
        this.setState({
            cursor: -1,
            products: [],
            totalResults: 0,
            searchQuery: "",
            didClear: true
        }, () => {
            this.viewResult();
        });
    }

    setActive() {
        const navigation = this.props.store.navigation;
        // if (this.state.products.length === 0 && this.state.searchQuery && this.state.searchQuery.length > 2) {
        //     const products = (navigation.products && navigation.products.length > 30) ? navigation.products.slice(0, 30) : navigation.products;
        //     this.setState({products: products, totalResults: navigation.products.length});
        // }
        this.setState({isActive: true, fontClasses: ["fas", "times"]});
        navigation.setNavigationVisible(true);
    }

    setNotActive() {
        const navigation = this.props.store.navigation;
        this.setState({isActive: false, fontClasses: ["fas", "search"]});
        navigation.setNavigationVisible(false);
    }

    submitForm(e) {
        e.preventDefault();
        //console.debug("Submit");
    }

    viewResult() {
        const navigation = this.props.store.navigation;
        this.setState({isActive: false});
        // const query = queryString.parse(navigation.mainRouter.location.search);
        // if (this.state.searchQuery) {
        //     query["q"] = this.state.searchQuery;
        // } else if (query["q"]) {
        //     delete query["q"];
        // }

        navigation.navigateToSiteUrl(null, this.props.store.navigation.mainTree.SearchUrl, null, null, {"q": this.state.searchQuery}); //queryString.stringify(query));

        if (this.state.didClear) {
            this.setState({
                didClear: false
            });
            return;
        }
        navigation.closeToolbar(true);

    }

    handleSearch(e) {
        this.setState({isActive: true});
        const searchQuery = e.target.value;
        this.setState({searchQuery: searchQuery});

        if (searchQuery.length < 2) {
            this.setState({products: [], totalResults: 0});
            return;
        }

        this.searchProducts(searchQuery);
    }

    async searchProducts(input) {
        const navigation = this.props.store.navigation;
        const url = this.props.store.navigation.mainTree.SearchUrl;

        const query = "q=" + input;

        const res = await this.request("/Umbraco/Api/Content/Getnode?url=" + url + "&" + query, //self.currentUrl,
            {
                Url: url,
                SiteId: navigation.SiteId,
                CustomerId: navigation.UrlCustomerId,
                MarketCode: navigation.MarketCode,
                CultureCode: navigation.CultureCode,
                CountryCode: navigation.CountryCode,
                ProductsOnly: true,
                ProductsFrom: 0
            });
        const products = (res.Products && res.Products.length > 30) ? res.Products.slice(0, 30) : res.Products;

        this.setState({products: products, cursor: -1, totalResults: res.TotalResults});

    }

    async request(path, query = {}) {
        const res = await axios.post(`${path}`, query);
        return res.data;
    }

    formatProduct(product) {
        return (<div className="row mx-5">
            <div className="col-3">
                <img src={product.PrimaryImageUrl ? product.PrimaryImageUrl : "/umbraco/ucommerce/images/ui/image_not_found.jpg"} style={{width: 80}}/>
            </div>
            <div className="col-9"><strong>{product.Name}</strong><br/>{product.Sku}</div>
        </div>);
    }

    openProduct(product) {
        console.debug("openProduct", product);
        this.setState({isActive: false});
        if (product && product.Sku) {
            const navigation = this.props.store.navigation;

            navigation.openProductDialog(product, {listIndex: -1, variantOptions: product.UrlSlug});
            //navigation.openProductDialog(product, ); //"q=" + this.state.searchQuery);
            //this.close();
        }
    }

    handleKeyDown(e) {
        const {cursor, products} = this.state;
        // todo: handle scrollInToView
        // arrow up/down button should select next/previous list element
        if (e.keyCode === 38 && cursor > 0) {
            e.preventDefault();

            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (e.keyCode === 40 && cursor < products.length - 1) {
            e.preventDefault();
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        } else if (e.keyCode === 13 && cursor >= 0 && cursor < products.length) {
            console.debug("key", e.keyCode);
            e.preventDefault();
            this.openProduct(this.state.products[cursor]);
        } else if (e.keyCode === 13) {
            e.preventDefault();
            this.viewResult();
        }
    }


    render() {
        this.hasFooter = this.props.hasFooter || false;
        const classes = [
            "toolbar-dropdown",
            "open",
            this.props.wide ? "wide" : null,
            this.props.left ? "left" : null,
            this.hasFooter ? "has-footer" : null,
            this.props.hideHeader ? "no-header" : null,
            this.props.isNavigation ? "nav-background" : null,
            this.props.className,
        ];

        const {store} = this.props;
        const navigation = this.props.store.navigation;
        const {cursor} = this.state;
        const serverRender = typeof window === 'undefined';

        const headerClasses = [
            "header",
            "checkout",
            this.headerExpanded ? "expanded" : null
        ];

        const footerClasses = [
            "footer",
            "checkout",
            this.footerExpanded ? "expanded" : null
        ];

        const parentMatch = this.props.match;

        let searchClasses = "search inline-search";

        if (this.state.isActive) {
            searchClasses += " active";
        }

        if (!navigation.isMobile) {
            searchClasses += " desktop";
        }


        return (


            <div className="search-container">
                
                <div className="search-inner">
                    <div className="search-header">
                        <form className="search-form " method="get" action="." onSubmit={(e) => this.submitForm(e)}>
                            <input
                                type="search"
                                autoFocus
                                value={this.state.searchQuery ? this.state.searchQuery : ""}
                                onChange={(e) => {
                                    this.handleSearch(e);
                                }}
                                onClick={(e) => this.setActive()}
                                onKeyDown={(e) => {
                                    this.handleKeyDown(e)
                                }}
                                placeholder={this.props.store.navigation.dictionary.Search}/><FontAwesomeIcon icon={this.state.fontClasses} className={"toggle"} size="xs" onClick={() => this.clearSearchQuery()}/>
                        </form>
                    </div>
                    <div className="search-result scroll-content">
                        {this.state.products.map((product, index) => {
                            const rowClasses = [
                                "search-result-row",

                                cursor === index ? "active" : null
                            ];

                            const orderlines = this.props.store.order && this.props.store.order.activeOrder && this.props.store.order.activeOrder.OrderLinesBySku(product.Sku, product.VariantSku);
                            const quantity = orderlines != null && orderlines.length > 0 ? orderlines[0].Quantity : 0;
                            const packSize = parseInt(product.Properties.PackSize);
                            const increments = isNaN(packSize) ? 1 : packSize;

                            const productBrand = product.Properties.f_Brand && product.Properties.f_Brand[0] || ""; //product.PropertyByKey("f_Brand");
                            const stockStatus = product.Properties.StockStatus;
                            let textAddButton = "Lägg till";
                            let addButtonEnabled = true;
                            switch (stockStatus) {
                                case "PreBook":
                                    if (navigation.isD2C) {
                                        textAddButton = "Kommer snart";
                                        addButtonEnabled = false;
                                    } else {
                                        textAddButton = "Förboka";
                                    }

                                    break;
                                case  "OutOfStock":
                                    textAddButton = "Slut för säsong";
                                    addButtonEnabled = false;
                                    break;
                                case "TemporaryOutOfStock":
                                    textAddButton = "Kommer snart";
                                    addButtonEnabled = false;
                                    break;
                            }

                            return (
                                <div key={product.ProductId}
                                     style={{cursor: "pointer"}}
                                     onClick={(e) => {
                                         this.openProduct(product);
                                     }}
                                     className={rowClasses.join(" ")}>
                                    <div className="row" style={{margin: "0px"}}>
                                        <div className="col-3 pr-0">
                                            {product.PrimaryImageUrl !== ""
                                                ? <img src={getBoxPadUrl(product.PrimaryImageUrl, 160, 160, "webp", "ffffff").url}/>

                                                : <img src="/dist/img/no_image.jpg" style={{width: 160}}/>
                                            }
                                        </div>
                                        <div className="col d-flex flex-column">
                                            {productBrand && <strong>{productBrand}<br/></strong>}
                                            {product.DisplayName}
                                            <div className="search-short-desc">{product.ShortDescription}</div>
                                            <div className={"d-flex flex-row align-items-end flex-grow-1 justify-content-center"}>
                                                <div>
                                                    <QuantityEdit
                                                        orderStore={this.props.store.order}
                                                        sku={product.Sku}
                                                        variantSku={product.VariantSku}
                                                        quantity={quantity}
                                                        increments={increments}
                                                        textAddButton={textAddButton}
                                                        disabled={!addButtonEnabled}
                                                    />
                                                </div>
                                                <div className={"ml-auto d-flex flex-column align-items-end "}>

                                                    {product.ListPrice !== product.Price &&
                                                        <span className="product-card-listprice-value">
                                                                            {navigation.isD2C
                                                                                ? product.ListPriceFormatted
                                                                                : product.ListPriceExFormatted} {product.Currency}
                                                                        </span>
                                                    }
                                                    <span key={"product_card_price"} className={"product-card-price-value " +
                                                        (product.ListPrice !== product.Price
                                                            ? "product-card-price-discounted"
                                                            : "")}>
                                                                            {navigation.isD2C
                                                                                ? product.PriceFormatted
                                                                                : product.PriceExFormatted} {product.Currency}
                                                                        </span>

                                                </div>
                                            </div>


                                        </div>
                                    </div>

                                </div>);
                        })}

                    </div>
                    <div className="search-footer">
                        <div className="col-12 search-cta-container">
                            {this.state.totalResults > 0 && <button className="product-button-purchase" onClick={(e) => {
                                this.viewResult();
                            }}>{this.props.store.navigation.dictionary.ViewResult} {this.state.totalResults}</button>}
                        </div>
                    </div>

                </div>
            </div>

        );
    }
}


export default withRouter(SearchViewModal);